/**
 * @file Created on Tue Sep 18 2018
 * @author LZe
 */

import DataUploadResult from './DataUploadResult';

export default DataUploadResult;
